module.exports = __webpack_public_path__ + "img/axelerate-logo-white.e0253464.svg";